export interface IPairKey {
  publicKey: string;
  privateKey: string;
}

export interface IGlobalSupportUserKeys {
  globalSupportPublicKey: string;
}
export interface ISupportUserKeys {
  encryptedGlobalSupportPrivateKey: { withUserPublicKey: string };
  encryptedPrivateKey: { withUserSecret: string };
  publicKey: string;
}

export interface IEndUserKeys {
  encryptedPrivateKey: { withUserSecret: string; withGlobalSupportPublicKey: string };
  publicKey: string;
}

export const userTypes = {
  ENDUSER: 'endUser',
  SUPPORTUSER: 'supportUser',
} as const;

export type TUserType = keyof typeof userTypes;
